import React from "react";
import { Stack, Text, Icon } from "@fluentui/react";
import { useTheme } from "cayo.ui";
import { freemiumMessages } from "../messages";
import { useIntl } from "react-intl";

export const TrialFeatureList = () => {
  const { officeTheme } = useTheme();
  const { formatMessage } = useIntl();

  const features = [
    { icon: "FullHistory", text: formatMessage(freemiumMessages.featureUnlimitedHistory) },
    { icon: "Rotate", text: formatMessage(freemiumMessages.featureRollback) },
    { icon: "Ringer", text: formatMessage(freemiumMessages.featureAlerts) },
    { icon: "SecurityGroup", text: formatMessage(freemiumMessages.featureDelegation) },
    { icon: "ProcessMetaTask", text: formatMessage(freemiumMessages.featureSettings) },
    { icon: "Processing", text: formatMessage(freemiumMessages.featureJobs) },
  ];

  return (
    <Stack
      tokens={{ childrenGap: 12, padding: 16 }}
      styles={{
        root: {
          width: "100%",
          maxHeight: "240px",
          background: officeTheme.palette.themeLighter,
          borderRadius: 6,
        },
      }}
    >
      {features.map((f, idx) => (
        <Stack horizontal verticalAlign="center" tokens={{ childrenGap: 8 }} key={idx}>
          <Icon
            iconName={f.icon}
            styles={{ root: { fontSize: 18, color: officeTheme.semanticColors.inputIcon } }}
          />
          <Text>{f.text}</Text>
        </Stack>
      ))}

      <Text
        variant="small"
        styles={{ root: { color: officeTheme.semanticColors.inputPlaceholderText, marginTop: 8 } }}
      >
        {formatMessage(freemiumMessages.andMore)}
      </Text>
    </Stack>
  );
};
